<template>
   <div class="account">
      <div class="mobil_padding">
         <router-link class="header__pricing" :to="{ name: 'setting' }">
            <div class="img__pricing">
               <svg xmlns="http://www.w3.org/2000/svg" width="17" height="13" viewBox="0 0 17 13" fill="none">
                  <path
                     fill-rule="evenodd"
                     clip-rule="evenodd"
                     d="M7.57391 12.4252C7.30054 12.6986 6.85732 12.6986 6.58396 12.4252L1.15341 6.99466C0.880043 6.72129 0.880043 6.27808 1.15341 6.00471L6.58396 0.574165C6.85732 0.300798 7.30054 0.300798 7.57391 0.574165L8.17495 1.17521C8.44831 1.44857 8.44831 1.89179 8.17495 2.16516L4.96484 5.37526L16.2482 5.37526C16.594 5.37526 16.875 5.67788 16.875 6.05026V6.95026C16.875 7.32263 16.594 7.62526 16.2482 7.62526L4.96599 7.62526L8.17495 10.8342C8.44831 11.1076 8.44831 11.5508 8.17495 11.8242L7.57391 12.4252Z"
                  />
               </svg>
            </div>
            <div class="back__pricing">
               <Typography :weigth="'weigth'" :size="'bigger'">Account</Typography>
            </div>
         </router-link>
      </div>
      <div class="account-content">
         <div class="thmeme-mode-item">
            <Typography class="colorCurrent" :size="'small'"> {{ $t('Account.fontSize') }} </Typography>
            <div>
               <ul class="list-font-size">
                  <li
                     class="list-font-size-item"
                     :class="`${size} ${fontSize === size ? 'active' : ''}`"
                     v-for="size in sizes"
                     :key="size"
                  >
                     <button @click="changeFontSize(size)">A</button>
                  </li>
               </ul>
            </div>
         </div>
         <div class="thmeme-mode-item">
            <Typography class="colorCurrent" :size="'small'"> {{ $t('Account.nigthMode') }}</Typography>
            <SWSwitcher v-model="nigthMode" />
         </div>

         <div class="profile-items">
            <div class="profile-item photo">
               <div class="image">
                  <img :src="image" />
               </div>
               <div>
                  <SWButton :size="'small'" variant="secondary" @click="$refs.imageInput.click()">
                     <Typography class="colorBtnText"> {{ $t('Account.selectImage') }} </Typography>
                  </SWButton>
                  <input
                     ref="imageInput"
                     style="display: none"
                     type="file"
                     accept="image/*, .heic, .heif"
                     @change="readFileUrl"
                     @click="imgErrorMessage = false"
                  />
               </div>
               <span v-if="imgErrorMessage" class="imgError"> the image size is too large</span>
            </div>
            <form @submit.prevent autocomplete="off">
               <div class="profile-item">
                  <SWInput
                     v-model="profile.first_name"
                     :isError="$v.profile.first_name.$error && !!firstNameError"
                     @input="$v.profile.first_name.$touch()"
                     @blur.capture="clearErrorOnBlur('first_name')"
                     :placeholder="$t('Account.placeholderFirstName')"
                     :errorMessage="firstNameError"
                     name="first_name"
                     autocomplete="first_name"
                  />
               </div>
               <div class="profile-item">
                  <SWInput
                     v-model="profile.email"
                     :placeholder="$t('Account.placeholderEmail')"
                     type="email"
                     name="email"
                     :isError="$v.profile.email.$error && !!emailError"
                     :errorMessage="emailError"
                     @blur.capture="clearErrorOnBlur('email')"
                     @input="$v.profile.email.$touch()"
                     autocomplete="email"
                  />
               </div>
               <div class="profile-item">
                  <SWInput
                     v-model="profile.phone"
                     :isError="$v.profile.phone.$error && !!phoneError"
                     @blur.capture="clearErrorOnBlur('phone')"
                     @input="onPhoneInput"
                     :errorMessage="phoneError"
                     :placeholder="$t('Account.placeholderPhone')"
                     type="tel"
                     name="tel"
                     autocomplete="tel"
                     :maxlength="16"
                  />
               </div>

               <SWButton variant="secondary" type="button" fullWidth @click="ischangePassOpen" :disabled="false">
                  <Typography class="colorBtnText">
                     {{ $t('Account.changePass') }}
                  </Typography>
               </SWButton>
               <transition name="fade">
                  <div v-if="showChangePasswordInput" class="changePassword">
                     <div class="profile-item placeholder">
                        <SWInput
                           :errorMessage="currentPasswordError"
                           :isError="$v.currentPassword.$error && !!currentPasswordError"
                           @blur.capture="$v.currentPassword.$reset()"
                           @input="$v.currentPassword.$touch()"
                           v-model="currentPassword"
                           :placeholder="showOnlyNewPasswordRequired ? 'Newol password' : 'Current Password'"
                           ref="currentpassword"
                           :type="showCurrentPassword ? 'text' : 'password'"
                        />
                        <button
                           type="button"
                           class="password-toggle"
                           @click="showCurrentPassword = !showCurrentPassword"
                           :aria-label="showCurrentPassword ? 'Hide password' : 'Show password'"
                        >
                           <span class="password-icon-wrapper" v-if="!showCurrentPassword">
                              <svg width="10px" height="10px" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                              <path
                                 fill-rule="evenodd"
                                 clip-rule="evenodd"
                                 d="M14.7649 6.07595C14.9991 6.22231 15.0703 6.53078 14.9239 6.76495C14.4849 7.46742 13.9632 8.10644 13.3702 8.66304L14.5712 9.86405C14.7664 10.0593 14.7664 10.3759 14.5712 10.5712C14.3759 10.7664 14.0593 10.7664 13.8641 10.5712L12.6011 9.30816C11.8049 9.90282 10.9089 10.3621 9.93374 10.651L10.383 12.3276C10.4544 12.5944 10.2961 12.8685 10.0294 12.94C9.76266 13.0115 9.4885 12.8532 9.41703 12.5864L8.95916 10.8775C8.48742 10.958 8.00035 10.9999 7.5 10.9999C6.99964 10.9999 6.51257 10.958 6.04082 10.8775L5.58299 12.5864C5.51153 12.8532 5.23737 13.0115 4.97063 12.94C4.7039 12.8685 4.5456 12.5944 4.61706 12.3277L5.06624 10.651C4.09111 10.3621 3.19503 9.90281 2.3989 9.30814L1.1359 10.5711C0.940638 10.7664 0.624058 10.7664 0.428797 10.5711C0.233537 10.3759 0.233537 10.0593 0.428797 9.86404L1.62982 8.66302C1.03682 8.10643 0.515113 7.46742 0.0760677 6.76495C-0.0702867 6.53078 0.000898544 6.22231 0.235064 6.07595C0.46923 5.9296 0.777703 6.00078 0.924057 6.23495C1.40354 7.00212 1.989 7.68056 2.66233 8.2427C2.67315 8.25096 2.6837 8.25971 2.69397 8.26897C4.00897 9.35527 5.65536 9.9999 7.5 9.9999C10.3078 9.9999 12.6563 8.50629 14.0759 6.23495C14.2223 6.00078 14.5308 5.9296 14.7649 6.07595Z"
                                 
                              />
                              </svg>
                           </span>
                           <span class="password-icon-wrapper" v-else>
                              <svg fill="currentColor" width="10px" height="10px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M21.92,11.6C19.9,6.91,16.1,4,12,4S4.1,6.91,2.08,11.6a1,1,0,0,0,0,.8C4.1,17.09,7.9,20,12,20s7.9-2.91,9.92-7.6A1,1,0,0,0,21.92,11.6ZM12,18c-3.17,0-6.17-2.29-7.9-6C5.83,8.29,8.83,6,12,6s6.17,2.29,7.9,6C18.17,15.71,15.17,18,12,18ZM12,8a4,4,0,1,0,4,4A4,4,0,0,0,12,8Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,12,14Z"/></svg>
                           </span> 
                        </button>
                        <!-- <span
                        @click="goToInput"
                        v-if="newPassword.length === 0 && !($v.newPassword.$error && !!passwordError)"
                        class="text"
                        >{{ $t('Account.placeholderPasswordhint') }}</span
                     > -->
                     </div>
                     <div v-if="!showOnlyNewPasswordRequired" class="profile-item placeholder">
                        <SWInput
                           :errorMessage="passwordError"
                           :isError="($v.currentPassword.$error && !!currentPasswordError) || passwordRequired"
                           @blur.capture="$v.newPassword.$reset()"
                           @input="$v.newPassword.$touch()"
                           v-model="newPassword"
                           :placeholder="$t('Account.placeholderPassword')"
                           ref="password"
                           :type="showNewPassword ? 'text' : 'password'"
                        />
                        <!-- <span
                        @click="goToInput"
                        v-if="newPassword.length === 0 && !($v.newPassword.$error && !!passwordError)"
                        class="text"
                        >{{ $t('Account.placeholderPasswordhint') }}</span
                     > -->
                        <button
                           type="button"
                           class="password-toggle"
                           @click="showNewPassword = !showNewPassword"
                           :aria-label="showNewPassword ? 'Hide password' : 'Show password'"
                        >
                           <span class="password-icon-wrapper" v-if="!showNewPassword">
                              <svg width="10px" height="10px" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                              <path
                                 fill-rule="evenodd"
                                 clip-rule="evenodd"
                                 d="M14.7649 6.07595C14.9991 6.22231 15.0703 6.53078 14.9239 6.76495C14.4849 7.46742 13.9632 8.10644 13.3702 8.66304L14.5712 9.86405C14.7664 10.0593 14.7664 10.3759 14.5712 10.5712C14.3759 10.7664 14.0593 10.7664 13.8641 10.5712L12.6011 9.30816C11.8049 9.90282 10.9089 10.3621 9.93374 10.651L10.383 12.3276C10.4544 12.5944 10.2961 12.8685 10.0294 12.94C9.76266 13.0115 9.4885 12.8532 9.41703 12.5864L8.95916 10.8775C8.48742 10.958 8.00035 10.9999 7.5 10.9999C6.99964 10.9999 6.51257 10.958 6.04082 10.8775L5.58299 12.5864C5.51153 12.8532 5.23737 13.0115 4.97063 12.94C4.7039 12.8685 4.5456 12.5944 4.61706 12.3277L5.06624 10.651C4.09111 10.3621 3.19503 9.90281 2.3989 9.30814L1.1359 10.5711C0.940638 10.7664 0.624058 10.7664 0.428797 10.5711C0.233537 10.3759 0.233537 10.0593 0.428797 9.86404L1.62982 8.66302C1.03682 8.10643 0.515113 7.46742 0.0760677 6.76495C-0.0702867 6.53078 0.000898544 6.22231 0.235064 6.07595C0.46923 5.9296 0.777703 6.00078 0.924057 6.23495C1.40354 7.00212 1.989 7.68056 2.66233 8.2427C2.67315 8.25096 2.6837 8.25971 2.69397 8.26897C4.00897 9.35527 5.65536 9.9999 7.5 9.9999C10.3078 9.9999 12.6563 8.50629 14.0759 6.23495C14.2223 6.00078 14.5308 5.9296 14.7649 6.07595Z"
                                 
                              />
                              </svg>
                           </span>
                           <span class="password-icon-wrapper" v-else>
                              <svg fill="currentColor" width="10px" height="10px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M21.92,11.6C19.9,6.91,16.1,4,12,4S4.1,6.91,2.08,11.6a1,1,0,0,0,0,.8C4.1,17.09,7.9,20,12,20s7.9-2.91,9.92-7.6A1,1,0,0,0,21.92,11.6ZM12,18c-3.17,0-6.17-2.29-7.9-6C5.83,8.29,8.83,6,12,6s6.17,2.29,7.9,6C18.17,15.71,15.17,18,12,18ZM12,8a4,4,0,1,0,4,4A4,4,0,0,0,12,8Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,12,14Z"/></svg>
                           </span>
                        </button>
                     </div>
                  </div>
               </transition>
            </form>
         </div>

         <div class="connect">
            <Typography class="colorBtnText" :weigth="'500'">{{ $t('Account.connect') }}</Typography>
            <div class="connect-items">
               <SWButton
                  :class="{ connected: connectedProviders.google, active: activeProvider === 'google' }"
                  :disabled="activeProvider === 'google'"
                  :size="'small'"
                  variant="secondary"
                  @click="onClickGoogle"
                  :title="connectedProviders.google ? 'Connected' : 'Not connected'"
               >
                  <Typography class="colorBtnText">{{ $t('Account.google') }}</Typography>
               </SWButton>

               <SWButton
                  :class="{ connected: connectedProviders.twitter, active: activeProvider === 'twitter' }"
                  :disabled="activeProvider === 'twitter'"
                  :size="'small'"
                  variant="secondary"
                  @click="onClickTwitter"
                  :title="connectedProviders.twitter ? 'Connected' : 'Not connected'"
               >
                  <Typography class="colorBtnText">{{ $t('Account.twitter') }}</Typography>
               </SWButton>

               <SWButton
                  :class="{ connected: connectedProviders.facebook, active: activeProvider === 'facebook' }"
                  :disabled="activeProvider === 'facebook'"
                  :size="'small'"
                  variant="secondary"
                  @click="onClickFacebook"
                  :title="connectedProviders.facebook ? 'Connected' : 'Not connected'"
               >
                  <Typography class="colorBtnText">{{ $t('Account.facebook') }}</Typography>
               </SWButton>
            </div>
         </div>

         <div class="save">
            <SWButton
               :disabled="!isFormCorrert || isSaving"
               type="submit"
               fullWidth
               @click="onSave"
            >
               <Typography class="colorButton">
                  <span v-if="!isSaving">
                     {{ $t('Account.save') }}
                  </span>
                  <span v-else>
                     {{ $t('Account.saving') || 'Saving...' }}
                  </span>
               </Typography>
            </SWButton>
         </div>
      </div>
      <Notification
         :show="notificationShowed"
         :text="notificationText"
         :color="notificationColor"
         @closeNotification="closeNotification"
      />
   </div>
</template>

<script>
import { SWSwitcher, SWButton, SWInput } from 'sw-ui-kit';
import Typography from '../../../components/UI/Typography.vue';
import { validationMixin } from 'vuelidate';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import { hasPassword, hasPhoneE164 , hasEmail } from '../../../validation/validation';
import { DEFAULT_SIZE, KEY_FONT_SIZE, KEY_THEME, SIZES } from '../../../store/themeModes';
import remoteOrigin from '../../../store/remoteOrigin';
//import log from '../../../logger/logger';
import Notification from '../../../components/UI/Notification.vue';

export default {
   MAX_FILE_SIZE: 1000000,
   components: { Typography, SWSwitcher, SWButton, SWInput, Notification },
   mixins: [validationMixin],
   inject: ['changeThemeMode', 'changeFontSizeStyle'],

   data() {
      return {
         fontSize: DEFAULT_SIZE,
         nigthMode: false,
         imgErrorMessage: false,
         newPassword: '',
         currentPassword: '',
         profile: { email: '', phone: '', first_name: '' },
         file: '',
         currentProfile: { email: '', phone: '', first_name: '' },
         showPlaceholder: true,
         showChangePasswordInput: false,
         showOnlyNewPasswordRequired: false,
         passwordRequired: false,
         notificationText: '',
         notificationColor: '',
         notificationShowed: false,
         backendImg: null,
         showCurrentPassword: false,
         showNewPassword: false,
         isSaving: false,
      };
   },
   validations: {
      newPassword: {
         required,
         hasPassword,
         maxLength: maxLength(20),
         minLength: minLength(8),
      },
      currentPassword: {
         required,
         hasPassword,
         maxLength: maxLength(20),
         minLength: minLength(8),
      },
      profile: {
         email: {
            required,
            hasEmail,
         },
         phone: {
            required,
            hasPhoneE164,
         },
         first_name: {
            required,
            maxLength: maxLength(32),
            minLength: minLength(1),
         },
      },
   },

   created() {
      this.requestUser();
   },

   mounted() {
      // this.$refs.currentpassword.$el.querySelector('input').onblur = this.removeErrorCurrentPassword;
      // this.$refs.password.$el.querySelector('input').onblur = this.removeErrorNewPassword;
      const fontSize = localStorage.getItem(KEY_FONT_SIZE);
      if (fontSize && SIZES.includes(fontSize)) this.fontSize = fontSize;

      let nigthMode;
      try {
         nigthMode = JSON.parse(localStorage.getItem(KEY_THEME));
      } catch {
         nigthMode = false;
      }

      this.nigthMode = nigthMode;

      const backendImg = localStorage.getItem('backend_img');
      if (backendImg) {
         this.backendImg = backendImg;
      }
     // log(this.$http, { message: 'visited page /settings/account', level: 'info' });
   },

   beforeDestroy() {
      //this.$refs.password.$el.querySelector('input').onblur = null;
      //this.$refs.currentpassword.$el.querySelector('input').onblur = null;
   },

   methods: {
      showNotification(text, color) {
         this.notificationShowed = true;
         this.notificationText = text;
         this.notificationColor = color;
      },
      closeNotification() {
         this.notificationShowed = false;
      },
      ischangePassOpen() {
         this.showChangePasswordInput = !this.showChangePasswordInput;
         this.showOnlyNewPasswordRequired = false;
      },
      goToInput() {
         this.$refs.password.$el.querySelector('input').focus();
      },
      onPhoneInput(value) {
         // value may be event.target.value or string
         // require for validation on input 
         const raw = typeof value === 'string' ? value : value?.target?.value || '';

         let sanitized = raw.replace(/[^\d+]/g, '');
         // garanty plas on begin
         if (sanitized.includes('+')) {
            sanitized = '+' + sanitized.replace(/\+/g, '').replace(/[^\d]/g, '');
         }
         // add + always
         if (!sanitized.startsWith('+') && sanitized.length > 0) {
            sanitized = '+' + sanitized.replace(/[^\d]/g, '');
         }
         //count (+ between 15 num)
         if (sanitized.length > 16) {
            sanitized = sanitized.slice(0, 16);
         }
         this.profile.phone = sanitized;
         this.$v.profile.phone.$touch();
      },
      removeErrorNewPassword() {
         if (this.newPassword.length === 0) this.$v.newPassword.$reset();
      },
      removeErrorCurrentPassword() {
         if (this.currentPassword.length === 0) this.$v.currentPassword.$reset();
      },
      clearErrorOnBlur(key) {
         if (this.profile[key].length === 0) this.$v.profile[key].$reset();
      },
      changeFontSize(size) {
         if (!size && !SIZES.includes(size)) return;
         this.fontSize = size;
      },
      sendnigthMode() {
         this.$root.$emit('nigthMode', this.nigthMode);
      },

      setImage(file) {
         this.profile.img = file;
      },

      requestUser() {
         this.$http.post('resources/profile').then(data => {
            this.profile = { ...data.data };
            this.currentProfile = { ...data.data };
            // fix for undefined or null string from backend
            if (
               this.profile.first_name &&
               /undefined|null/i.test(this.profile.first_name)
            ) {
               this.profile.first_name = '';
               this.currentProfile.first_name = '';
            }

            if (this.profile.img) {
               const full = this.origin + this.profile.img;
               localStorage.setItem('backend_img', full);
            }
         });
      },

      readAndSetImage(file) {
         const self = this;
         const reader = new FileReader();
         reader.onload = function (e) {
            self.setImage(e.target.result);
         };
         reader.readAsDataURL(file);
      },

      async readFileUrl(e) {
         const file = e.target.files[0];
         //TODO: handle error max size
         if (file.size >= this.$options.MAX_FILE_SIZE) {
            this.imgErrorMessage = true;
            return this.imgErrorMessage;
         }
         this.readAndSetImage(file);
         const formData = new FormData();
         formData.append('img', file);
         this.file = formData;
      },

      saveImage() {
         if (!this.file) return Promise.resolve();
         return this.$http
            .put('resources/profile', this.file, {
               headers: { 'Content-Type': 'multipart/form-data' },
            })
            .then(() => {
               this.currentProfile.img = this.profile.img;
               this.showNotification('Your avatar has been updated', 'info');
            });
      },

      updateFirstName(name) {
         return this.$http.put('resources/profile', { first_name: name }).then(() => {
            this.currentProfile.first_name = name;
            this.showNotification('Your name has been updated', 'info');
         });
      },

      async updatePhone(phone) {
         const data = { phone: phone, ...(this.currentPassword ? { password: this.currentPassword } : {}) };
         console.log('🚀 ~ file: Account.vue:366 ~ updatePhone ~ data:', data);

         try {
            const response = await this.$http.put('resources/profile/asign/phone', data);
            console.log(response);
            if (response) {
               this.requestUser();
               this.showNotification('Your phone has been updated', 'info');
            }
         } catch (e) {
            if (e.status === 400) {
               this.passwordRequired = true;
               this.showChangePasswordInput = true;
               this.showOnlyNewPasswordRequired = true;
               this.showNotification('New passwrod is required ', 'warning');
            }
            if (e.status === 403 && e.data.message === 'An account with this phone number already exists') {
               this.showNotification('An account with this phone number already exists ', 'danger');
            }
         }

         // console.log('updating phone');
         //this.$http.put('resources/profile', { phone: phone }).then(() => {});
      },

      async updateEmail(email) {
         const data = { email: email, ...(this.currentPassword ? { password: this.currentPassword } : {}) };
         try {
            const response = await this.$http.put('resources/profile/asign/email', data);
            if (response) {
               this.requestUser();
               this.showNotification('Your email has been updated', 'info');
            }
         } catch (e) {
            if (e.status === 400) {
               this.passwordRequired = true;
               this.showChangePasswordInput = true;
               this.showOnlyNewPasswordRequired = true;
               this.showNotification('New passwrod is required ', 'warning');
            }
            if (e.status === 403 && e.data.message === 'Email already exists') {
               this.showNotification('An account with this email already exists ', 'danger');
            }
         }

         //this.$http.put('resources/profile', { email: email }).then(() => {});
      },
      async changePassword() {
         try {
            await this.$http.put('resources/profile/password', {
               password: this.currentPassword,
               new_password: this.newPassword,
            });

            this.showNotification('Password has been changed', 'info');
         } catch (error) {
            this.showNotification('Invalid password', 'danger');
            this.$refs['form'].reset();
         }
      },

      // updatePassword(password) {
      //    this.$http.put('resources/newPassword', { newPassword: password }).then(() => {});
      // },

      async onSave() {
         if (this.isSaving || !this.isFormCorrert) return;

         this.isSaving = true;
         let hasChanges = false;

         try {
            if (this.profile.img && this.profile.img !== this.currentProfile.img) {
               await this.saveImage();
               hasChanges = true;
            }

            if (this.profile.first_name && this.profile.first_name !== this.currentProfile.first_name) {
               await this.updateFirstName(this.profile.first_name);
               hasChanges = true;
            }

            if (this.profile.phone && this.profile.phone !== this.currentProfile.phone) {
               this.$v.profile.phone.$touch();
               if (this.$v.profile.phone.$error) {
                  this.showNotification('Enter a valid phone number in format +380671234567', 'warning');
                  return;
               }

               await this.updatePhone(this.profile.phone.trim());
               hasChanges = true;
            }

            if (this.profile.email && this.profile.email !== this.currentProfile.email) {
               await this.updateEmail(this.profile.email);
               hasChanges = true;
            }

            if (
               this.showChangePasswordInput &&
               !this.currentPasswordError &&
               !this.passwordError &&
               !this.passwordRequired
            ) {
               await this.changePassword();
               this.showChangePasswordInput = false;
               this.newPassword = '';
               this.currentPassword = '';
               hasChanges = true;
            }
            // Update user data after all changes
            if (hasChanges) {
               await this.requestUser();
               this.showNotification('Changes saved successfully', 'info');
            } else {
               this.showNotification('There is nothing to save', 'info');
            }
         } catch (e) {
            // If any operation fails — show a general message
            this.showNotification('Something went wrong while saving changes', 'danger');
         } finally {
            this.isSaving = false;
         }
      },

      disabled() {
         if (this.isFormCorrert) {
            return;
         }
      },

      async onClickGoogle() {
         // якщо не підключений — просто біндимо як раніше
         if (!this.profile?.google_id) {
            return this.bindGoogle();
         }

         // якщо це primary — не даємо відв’язати
         if (this.activeProvider === 'google') {
            this.showNotification(
            'You cannot disconnect your primary login provider',
            'warning'
            );
            return;
         }

         // підключений, але не primary → пропонуємо відв’язати
         const confirmed = window.confirm(
            'Are you sure you want to disconnect Google account?'
         );
         if (!confirmed) return;

         try {
            await this.$http.delete('resources/profile/asign/google');
            await this.requestUser();
            this.showNotification('Google account has been disconnected', 'info');
         } catch (e) {
            this.showNotification(
            'Something went wrong while disconnecting Google account',
            'danger'
            );
         }
      },

      async bindGoogle() {
         let url = await this.fetchGooleUrl();
         localStorage.isAssign = true;
         window.location.href = url;
      },

      async fetchGooleUrl() {
         let response = await this.$http.post('auth/google/login/url');
         return response.data.url;
      },

      async onClickTwitter() {
         if (!this.profile?.twitter_id) {
            return this.bindTwitter();
         }

         if (this.activeProvider === 'twitter') {
            this.showNotification(
            'You cannot disconnect your primary login provider',
            'warning'
            );
            return;
         }

         const confirmed = window.confirm(
            'Are you sure you want to disconnect X (Twitter) account?'
         );
         if (!confirmed) return;

         try {
            await this.$http.delete('resources/profile/asign/twitter');
            await this.requestUser();
            this.showNotification('X (Twitter) account has been disconnected', 'info');
         } catch (e) {
            this.showNotification(
            'Something went wrong while disconnecting X (Twitter) account',
            'danger'
            );
         }
      },

      async bindTwitter() {
         let url = await this.fetchTwitterUrl();
         localStorage.isAssign = true;
         window.location.href = url;
      },

      async fetchTwitterUrl() {
         let response = await this.$http.post(
            'auth/twitter/login/url',
            null,
            { withCredentials: true }
         );
         return response.data.redirectUrl;
      },

      async onClickFacebook() {
         if (!this.profile?.facebook_id) {
            return this.bindFacebook();
         }

         if (this.activeProvider === 'facebook') {
            this.showNotification(
            'You cannot disconnect your primary login provider',
            'warning'
            );
            return;
         }

         const confirmed = window.confirm(
            'Are you sure you want to disconnect Facebook account?'
         );
         if (!confirmed) return;

         try {
            await this.$http.delete('resources/profile/asign/facebook');
            await this.requestUser();
            this.showNotification('Facebook account has been disconnected', 'info');
         } catch (e) {
            this.showNotification(
            'Something went wrong while disconnecting Facebook account',
            'danger'
            );
         }
      },

      async bindFacebook() {
         let url = await this.fetchFaceBookUrl();
         localStorage.isAssign = true;
         window.location.href = url;
      },

      async fetchFaceBookUrl() {
         let response = await this.$http.post('auth/facebook/login/url');
         return response.data.url;
      },
   },

   computed: {
      formMutex() {
         return (
            (this.profile.email && this.profile.email !== this.currentProfile.email) ||
            (this.profile.phone && this.profile.phone !== this.currentProfile.phone) ||
            (this.profile.img && this.profile.img !== this.currentProfile.img) ||
            (this.profile.first_name && this.profile.first_name !== this.currentProfile.first_name)
         );
      },

      passwordError() {
         if (this.newPassword && !this.$v.newPassword.required) return 'Enter your current or new password';
         if (!this.$v.newPassword.minLength) return 'Password must be at least 8 characters long';
         if (!this.$v.newPassword.maxLength) return 'Password must not exceed 20 characters';
         if (!this.$v.newPassword.hasPassword)
            return 'The password must have Latin capital and small letters,numbers and a special symbol ( ! @ # $ & + - ?)';
         return '';
      },
      currentPasswordError() {
         if (this.currentPassword && !this.$v.currentPassword.required) return 'Enter your current or new password';
         if (!this.$v.currentPassword.minLength) return 'Password must be at least 8 characters long';
         if (!this.$v.currentPassword.maxLength) return 'Password must not exceed 20 characters';
         if (!this.$v.currentPassword.hasPassword)
            return 'The password must have Latin capital and small letters,numbers and a special symbol ( ! @ # $ & + - ?)';
         return '';
      },

      emailError() {
         if (this.currentProfile.email && !this.$v.profile.email.required) return 'Enter your current or new email';
         if (!this.$v.profile.email.hasEmail)
            return 'The email can have Latin capital and small letters,numbers and a special symbol (! # $ % & ‘ * + — / = ? ^ _ ` { | } ~;)';
         return '';
      },
      firstNameError() {
         if (this.currentProfile.first_name && !this.$v.profile.first_name.required)
            return 'Enter your current or new name';
         if (!this.$v.profile.first_name.minLength) return 'The firstName must consist of a minimum of characters';
         if (!this.$v.profile.first_name.maxLength) return 'The firstName should not exceed 32 characters';
         if (!this.$v.profile.first_name.hasUpperlowerCase)
            return 'The name can have Latin capital and small letters, numbers and a special symbol (@ # $ ! & ? ^ _)';
         return '';
      },
      phoneError() {
         if (this.currentProfile.phone && !this.$v.profile.phone.required) {
            return 'Enter your current or new phone';
         }
         if (!this.$v.profile.phone.hasPhoneE164) {
            return 'Phone number must be in international E.164 format, for example: +380671234567';
         }
         return '';
      },
      isFormCorrert() {
         return !this.$v.profile.email.$error && !this.$v.profile.phone.$error && !this.$v.profile.first_name.$error;
      },
      sizes() {
         return SIZES;
      },
      userEmptyImage() {
         return require('../../../assets/img/userEmty.png');
      },

      origin() {
         return remoteOrigin;
      },

      image() {
         const backendImg = localStorage.getItem('backend_img');
         const socialImg = localStorage.getItem('social_img');

         // 1. Якщо юзер щойно вибрав файл — там dataURL
         if (this.profile.img) {
            if (typeof this.profile.img === 'string') {
               // нова картинка з FileReader
               if (this.profile.img.startsWith('data:')) {
                  return this.profile.img;
               }

               // раптом бек уже віддав повний URL
               if (this.profile.img.startsWith('http')) {
                  return this.profile.img;
               }

               // відносний шлях типу /storage/images/...
               return this.origin + this.profile.img;
            }

            // на всяк випадок — якщо там щось інше
            return this.profile.img;
         }


         // 2. Якщо є бекендова картинка — беремо її
         if (backendImg) return backendImg;

         // 3. Якщо нема бекендової, але є соцмережева — беремо її
         if (socialImg) return socialImg;

         // 4. Фолбек
         return this.userEmptyImage;
      }
      ,
      connectedProviders() {
         return {
            google: !!this.profile.google_id,
            facebook: !!this.profile.facebook_id,
            twitter: !!this.profile.twitter_id,
         }
      },
      activeProvider() {
         return this.profile.provider || null
      },
   },

   watch: {
      fontSize() {
         localStorage.setItem(KEY_FONT_SIZE, this.fontSize);
         this.changeFontSizeStyle(this.fontSize);
      },
      nigthMode() {
         localStorage.setItem(KEY_THEME, JSON.stringify(this.nigthMode));
         this.changeThemeMode(this.nigthMode);
      },
   },
};
</script>

<style scoped>
.account {
   width: 100%;
   overflow-y: auto;
}
/* .buttonCharacter {
   color: var(--color-character-acount);
} */

.changePassword {
   margin-top: 24px;
}

.account-content {
   margin: 0 auto;
   max-width: 340px;
   width: 100%;
}

.thmeme-mode-item {
   display: flex;
   align-items: center;
   justify-content: space-between;
   margin-bottom: 24px;
   padding: 3.5px 0 3.5px 24px;
}

.thmeme-mode-item:last-child {
   margin-bottom: 40px;
}

.list-font-size {
   margin-left: 16px;
   display: grid;
   grid-template-columns: repeat(3, 1fr);
   column-gap: 24px;
   align-items: center;
}

.list-font-size-item.small button {
   font-size: 16px;
}

.list-font-size-item.default button {
   font-size: 24px;
}

.list-font-size-item.big button {
   font-size: 30px;
}

.list-font-size-item button {
   font-weight: 400;
   transition: all 0.3s;
}
.list-font-size-item button {
   color: var(--typograohy-color);
}

.list-font-size-item:hover button {
   color: var(--shape-hover);
}

.active button {
   color: inherit;
}

.profile-items {
   margin-top: 40px;
}

.profile-item {
   margin-bottom: 24px;
   position: relative;
}

.profile-item.photo {
   display: flex;
   justify-content: space-between;
   align-items: center;
   margin-bottom: 32px;
}

.profile-item .image {
   width: 81px;
   height: 81px;
   border-radius: 50%;
   overflow: hidden;
}

.profile-item .image img {
   border-radius: 50%;
   width: 100%;
   height: 100%;
   object-fit: cover;
   object-position: center;
}

.placeholder {
   position: relative;
}

.placeholder .text {
   position: absolute;
   top: 50%;
   left: 50%;
   transform: translate(-16%, -50%);
   width: 100%;
   color: var(--text-desabled);
   font-size: 11px;
}

.placeholder-new-pass-on-error.text {
   top: 27%;
}

.connect {
   margin-top: 40px;
   text-align: center;
}

.connect-items {
   margin-top: 16px;
   display: grid;
   column-gap: 17px;
   grid-template-columns: repeat(3, 1fr);
}
.connect-items .secondary {
   opacity: 0.6;
}
.connect-items .connected {
   opacity: 1;
   transition: all 0.3s;
}
.connect-items .connected:hover {
   box-shadow: 0 0 0 1px var(--shape-hover);
}
.connect-items .active {
   opacity: 1;
   box-shadow: 0 0 0 1px var(--shape-hover);
}

.save {
   margin-top: 32px;
}

.header__pricing {
   display: flex;
   font-size: 24px;
   cursor: pointer;
   font-weight: 700;
   line-height: 31.2px;
}
.img__pricing {
   width: 20px;
   height: 12.26px;
   margin-right: 33px;
}
.img__pricing svg {
   fill: var(--font-color-primary);
}
.imgInput {
   position: relative;
}
.imgError {
   position: absolute;
   top: 100%;
   bottom: 0;
   font-size: 11px;
   left: 5px;
   color: var(--text-alert);
}
.back__pricing {
   color: var(--typograohy-color);
}
.colorBtnText {
   color: var(--color-current-typography) !important;
}
.colorCurrent {
   color: var(--color-character-acount) !important;
}
.colorButton {
   color: var(--color-button-darck-team) !important;
}

@media screen and (max-width: 650px) {
   .header__pricing {
      display: flex;
      justify-content: center;
      align-items: center;
   }
   .img__pricing {
      height: unset;
   }
   .mobil_padding {
      position: fixed;
      top: 0px;
      left: 0;
      padding: 15px 20px 15px 0px;
      width: 100%;
      background-color: var(--bg-install-element);
      /* padding-bottom: 20px; */
      z-index: 99;
   }
   /* .img__pricing {
      padding-top: 10px;
      padding-left: 19px;
   }*/
   .back__pricing p {
      font-size: 20px !important;
      /* padding-left: 108px;
      padding-top: 10px; */
   }
   .save {
      margin-bottom: 32px;
   }
}
@media screen and (max-width: 450px) {
   .account {
      height: unset;
   }
   .img__pricing {
      margin-right: 0;
      transform: translateX(-120px);
   }
   /* .back__pricing {
      transform: translateY(4px);
   } */
   /* .profile-items {
      margin-top: 20px;
   }
   .thmeme-mode-item {
      margin-bottom: 18px;
   }
   .profile-item {
      margin-bottom: 19px;
   }
   .connect {
      margin-top: 25px;
   }
   .layout_content {
      padding-bottom: 0px;
   } */
   .account-content {
      margin-top: 40px;
   }
}
@media screen and (max-width: 375px) {
   .thmeme-mode-item {
      margin-bottom: 7px;
   }
   .profile-item.photo {
      margin-bottom: 15px;
   }
   .connect {
      margin-top: 9px;
   }
   .save {
      margin-top: 13px;
   }
   .profile-items {
      margin-top: 12px;
   }
   .account-content {
      margin-top: 15px;
   }
   .profile-item {
      margin-bottom: 10px;
   }
}
.password-toggle {
   position: absolute;
   top: 25px;
   right: 12px;
   transform: translateY(-50%);
   border: none;
   background: transparent;
   cursor: pointer;
   padding: 0;
   display: flex;
   align-items: center;
   justify-content: center;
   font-size: 16px;
}
.password-icon-wrapper {
   display: block;
   width: 20px;
   height: 20px;
}
.password-icon-wrapper svg {
   width: 100%;
   height: 100%;
   object-fit: contain;
   color: var(--text);
}
</style>
